import { render, staticRenderFns } from "./applied.vue?vue&type=template&id=880788a6&scoped=true"
import script from "./applied.vue?vue&type=script&lang=js"
export * from "./applied.vue?vue&type=script&lang=js"
import style0 from "./applied.vue?vue&type=style&index=0&id=880788a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880788a6",
  null
  
)

export default component.exports